module.exports = __webpack_public_path__ + "static/img/a1.461b19c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/a1.png
// module id = vnqe
// module chunks = 1